import React, { useState, useEffect, memo } from "react";
import { makeStyles, createStyles } from "@material-ui/core/styles";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import NotTalkingIcon from "@material-ui/icons/MoreHoriz";

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      margin: theme.spacing(1),
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    bar: {
      margin: 1,
      borderRadius: 24,
      background: "#0CD3CD",
      height: (volume) => (volume > 0 ? volume * 2 + 3 : 3),
      width: "3px",
      animation: `$sound 0ms -800ms linear infinite alternate`,
      "&:nth-child(1)": { animationDuration: "674ms" },
      "&:nth-child(2)": { animationDuration: "533ms" },
      "&:nth-child(3)": { animationDuration: "607ms" },
    },
    "@keyframes sound": {
      "0%": {
        opacity: 1,
        height: "3px",
      },
      "100%": {
        opacity: 1,
        height: (volume) => (volume > 0 ? volume * 2 + 3 : 3),
      },
    },
    voiceActivityIcon: {
      color: "#0CD3CD",
      padding: 4,
      borderRadius: "50%",
      marginLeft: 5,
    },
  })
);

const SoundBar = ({ level = 5 }) => {
  const classes = useStyles(level);
  return (
    <div className={classes.root}>
      <div className={classes.bar} />
      <div className={classes.bar} />
      <div className={classes.bar} />
    </div>
  );
};

SoundBar.propTypes = {
  level: PropTypes.number,
};

const SoundBarMemoized = memo(SoundBar);
SoundBarMemoized.displayName = "SoundBar";

const SoundBarContainer = ({ id }) => {
  const classes = useStyles();
  const [level, setLevel] = useState(0);
  const volume = useSelector((state) => state.peerVolumes[id]);
  useEffect(() => {
    const min = level - 1;
    const max = level + 1;
    if (volume < min || volume > max) {
      setLevel(volume);
    }
  }, [volume, level]);

  if (volume < 3) {
    return <NotTalkingIcon className={classes.voiceActivityIcon} />;
  } else {
    return <SoundBar />;
  }
  //return <SoundBarMemoized level={level}></SoundBarMemoized>;
};

SoundBarContainer.propTypes = {
  id: PropTypes.string,
};

export default SoundBarContainer;
